import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {AllService} from '../../../services/all.service';
import {NotifierWrapService} from '../../../services/notifier-wrap.service';
import {FellowdeskService} from '../fellowdesk.service';
import {log} from '../../../functions';

@Component({
  selector: 'app-sign-fellowdesk',
  templateUrl: './sign-fellowdesk.component.html',
  styleUrls: ['./sign-fellowdesk.component.scss']
})
export class SignFellowdeskComponent implements OnInit {

  Form: UntypedFormGroup;
  _isLoading = false;
  constructor(
    private cd: ChangeDetectorRef,
    public allService: AllService,
    public notifierWrapService: NotifierWrapService,
    public fellowdeskService: FellowdeskService
  ) {}

  ngOnInit(): void {
    this.Form = new UntypedFormGroup({
      username: new UntypedFormControl('', Validators.required),
      password: new UntypedFormControl('', [Validators.required, Validators.minLength(1)])
    });
  }
  onSubmit() {
    this.isLoading = true;
    const controls = this.Form.controls;
    const values = this.Form.value;

    // Проверяем форму на валидность */
    if (this.Form.invalid) {
      // Если форма не валидна, помечаем все контролы как touched **/
      Object.keys(controls).forEach((controlName) => controls[controlName].markAsTouched());
      return;
    }
    this.fellowdeskService.authorize(values.username, values.password).subscribe(
      (result: any) => {
        log('fellowdeskService.login', result);
        this.fellowdeskService.loadProfile();
        this.goPage();
        this.isLoading = false;
      },
      (error) => {
        this.fellowdeskService.errorHandling(error);
        this.isLoading = false;
      }
    );
  }
  goPage(): void {
    // this.router.navigate([`/${this.fellowdeskService.type}/`]);
  }
  get isLoading() {
    return this._isLoading;
  }
  set isLoading(val) {
    this._isLoading = val;
    this.cd.detectChanges();
  }

}
